export function messageBoxConfig() {
    return {
        label: {
            maxWidth: "auto"
        }
    };
}
